import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './style.scss';

class BeerCard extends Component {
	render() {
		const { beer } = this.props;

		return (
			<React.Fragment>
				<Link to={{ pathname: `/beer/${beer.slug}`, state: { beer: beer } }}>
					<div className="wrapper">
						<div className="beer__glass">
							<div className="image">
								<img src={beer.glass_image} alt={`${beer.name}, ${beer.style}`} height="100" />
							</div>
							<p className={`beer__on-tap ${beer.on_tap && 'pouring-now'}`}>
								{beer.on_tap ? 'Pouring Now' : 'Not Pouring'}
							</p>
						</div>
						<div className="beer__details">
							<p className="beer__style">{beer.style}</p>
							<h3 className="beer__name">{beer.name}</h3>
							<p className="beer__abv">{beer.abv}%</p>
						</div>
					</div>
				</Link>
			</React.Fragment>
		);
	}
}

export default BeerCard;



// WEBPACK FOOTER //
// ./src/components/beer/card.js